if (!customElements.get("swiper-slider")) {
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        this.slideContainer = this.querySelector(
          "[data-swiper]:not([data-swiper-thumbs])"
        );
        this.video = false;
        this.center = false
        this.slides = this.querySelectorAll("[data-swiper-slide]");
        this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
        this.activeIndex = 0;
        this.initialized = false;
        if (this.dataset.swiperThumbs) {
          this.thumbnails = this.querySelector("[data-swiper-thumbs]");
        }
        if (this.dataset.swiperVideo) {
          this.video = true;
        }
        if (this.dataset.swiperCenter) {
          this.center = true;
        }
        if (this.dataset.customEvent) {
          this.attachCustomListeners(this.dataset.customEvent);
        }
        if (this.slideContainer && this.slides.length > 0) {
          document.addEventListener(
            "DOMContentLoaded",
            this.initializeSwiper.bind(this)
          );
          document.addEventListener(
            "shopify:section:load",
            this.initializeSwiper.bind(this)
          );
          window.addEventListener("resize", this.handleResize.bind(this));
          this.addEventListener("go-to-slide", this.goToSlide.bind(this));
        } else {
          console.warn("SwiperSlider - Slider or Slides Not Found");
        }
      }
  
      attachCustomListeners(customEvent) {
        switch (customEvent) {
          case "swiper_event":
            document.addEventListener(
              "swiper_event",
              this.updateSlides.bind(this)
            );
            break;
        }
      }
  
      updateSlides(event) {}
  
      goToSlide(evt) {
        let index = evt.detail.index;
        if (!index && evt.detail.position) {
          const elm = this.querySelector(
            "[data-position='" + evt.detail.position + "']"
          );
          index = [...elm.parentNode.children].indexOf(elm);
        }
        if (index != 0 && !index) return;
        this.slider.slideTo(index);
      }
  
      applyDefaultOptions(options) {
        if (options.loop === undefined) {
          options.loop = true;
        }
        options.speed = 400;
        return options;
      }
  
      getSliderOptions() {
        try {
          return JSON.parse(this.dataset.swiperOptions);
        } catch (err) {
          console.log(err);
          return {};
        }
      }
  
      initializeSwiper() {
        if (window.Swiper && !this.initialized) {
          this.initialized = true;
          if (this.thumbnails) {
            this.setThumbnails();
          }
          if (this.video) {
            this.setVideo();
          }
          if (this.center) {
            this.setResize();
          }
          this.slider = new Swiper(this.slideContainer, this.sliderOptions);
          this.initializeSliderEventListeners();
        } else if (!window.Swiper) {
          console.warn("SwiperSlider - Swiper.js not found");
        }
      }
  
      handleResize(e) {
        if (this.slider) {
          setTimeout(() => {
            this.slider.updateSize();
          }, 300);
        }
      }

      setResize() {
        this.sliderOptions.on = {
          init: function (instance) {
            this.el.classList.toggle('slider-active', instance.virtualSize > instance.size);
          },
          resize: function (instance) {
            this.el.classList.toggle('slider-active', instance.virtualSize > instance.size);
          }
        }
      }

      setVideo() {
        this.sliderOptions.on = {
          transitionStart: function() {
            var videos = document.querySelectorAll('.td-ugc__swiper--image video');
        
            Array.prototype.forEach.call(videos, function(video){
              if (video.previousElementSibling && video.previousElementSibling.classList.contains('td-ugc__swiper--icon-hide')) {
                video.previousElementSibling.classList.remove('td-ugc__swiper--icon-hide')
              }
              video.pause();
              video.removeAttribute('controls');
            });
          },
            
          transitionEnd: function() {
            var activeIndex = this.activeIndex;
            var activeSlide = document.getElementsByClassName('td-ugc__swiper--slide')[activeIndex];
            var activeSlideVideo = activeSlide.getElementsByTagName('video');
    
            if (activeSlideVideo[0]) {
              var icon = activeSlide.querySelector('.td-ugc__swiper--icon')
              icon.classList.add('td-ugc__swiper--icon-hide')
              activeSlideVideo[0].setAttribute('controls','');
              activeSlideVideo[0].play();
            }
          }
        }
      }
  
      setThumbnails() {
        try{
          const thumbsSlideContainer = this.thumbnails;
          const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
          const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
          this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
          this.sliderOptions.on = {
            slideChange: function () {
              const activeIndex = this.activeIndex;
              this.thumbs.swiper.slideTo(activeIndex);
            }
          };  
        } catch (err) {
          console.error('Error while setting thumbnails:', err);
        }
      }
  
      initializeSliderEventListeners() {}
    }
    customElements.define("swiper-slider", SwiperSlider);
  }